import Header from "../components/header"
import Banners from "../components/banners"
import { motion, AnimatePresence } from "framer-motion"
import React,{useState,useEffect} from "react"
import { myContext } from '../components/provider';
import Footer from "../components/footer";


function Layout({ children, location, containerClassName, isHome }) {
  // const [mounted, setMounted] = useState(false);
  // useEffect(() => {
  //     setMounted(true)
  // }, [])
  const duration = 0.3

  const variants = {
    initial: {
      opacity: 0,
    },
    enter: {
      opacity: 1,
      transition: {
        duration: duration,
        delay: duration,
        when: "beforeChildren",
      },
    },
    exit: {
      opacity: 0,
      transition: { duration: duration },
    },
  }

  return (
    <div>
      
      <myContext.Consumer>
       { context =>(
         <>
      <Banners close={context.exitBanner} isBannerOpen={context.isBannerOpen}/>
        <Header isHome={isHome}/>
        <AnimatePresence>
          <motion.main
            key={location.pathname}
            variants={variants}
            initial="initial"
            animate="enter"
            exit="exit"
          >
            <div className={`${containerClassName} min-h-hero`}>{children}</div>
          </motion.main>
        </AnimatePresence>
        <Footer />
        </>
        )}
      </myContext.Consumer>
    </div>
  )
}

export default Layout
